module.exports = "/contribution/resources/94b4d2031055743d7f8f9aca61255bf7.png";